export const osTypes = {
  Ios: 0,
  Android: 1,
  Web: 2,
};
